import { useMemo } from "react";
import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import FeaturedPosts from "./components/FeaturedPosts";
import LatestSection from "./components/LatestSection";
import CommunityCta from "./components/CommunityCta";
import { hotTopics, siteMeta } from "@/mocks/community";

export default function Home() {
  const jsonLd = useMemo(() => {
    const origin = window.location.origin;
    return [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteMeta.name,
        url: origin,
        description: siteMeta.intro,
        potentialAction: {
          "@type": "SearchAction",
          target: `${origin}/topics?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteMeta.name,
        url: origin,
        description: siteMeta.intro,
        email: siteMeta.email,
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "今日活跃话题榜",
        itemListElement: hotTopics.slice(0, 8).map((topic, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: topic.title,
          url: `${origin}/post/${topic.postId}`,
        })),
      },
    ];
  }, []);

  useSeo({
    title: "爆料社区 | 今日活跃话题榜，高互动爆料帖一网打尽",
    description:
      "爆料社区聚合今日活跃话题榜、高互动爆料帖与板块热榜内容，新帖热门讨论随时刷新。打开爆料社区，第一时间掌握热门话题与围观入口，轻松参与讨论。",
    keywords: "爆料社区,今日活跃话题,高互动爆料帖,新帖热门讨论,板块热榜",
    path: "/",
    type: "website",
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20background%20with%20flowing%20crimson%20and%20amber%20gradient%20shapes%20over%20cream%20paper%20texture%2C%20soft%20directional%20studio%20lighting%2C%20elegant%20modern%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=baoliao-hero-bg&orientation=landscape",
    jsonLd,
  });

  return (
    <SiteLayout>
      <Hero />
      <CategoryStrip />
      <FeaturedPosts />
      <LatestSection />
      <CommunityCta />
    </SiteLayout>
  );
}